import { ISegment } from '~/common/types';

export function getSegmentNameByPublicKeyLookup(
  segments: ISegment[],
): Record<string, ISegment['name']> {
  return segments.reduce(
    (dict, segment) => ({
      ...dict,
      [segment.publicKey]: segment.name,
    }),
    {},
  );
}
